import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/customs/reports',
}).lazy(() => import('./reports.lazy').then((d) => d.Route))
